'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isObject = isObject;
exports.deepMerge = deepMerge;
exports.classNames = classNames;
exports.handleKeyPress = handleKeyPress;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function isObject(item) {
  return item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && !Array.isArray(item);
}

function deepMerge(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if (!sources.length) return target;
  var source = sources.shift();

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, _defineProperty({}, key, {}));
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, _defineProperty({}, key, source[key]));
      }
    });
  }

  return deepMerge.apply(undefined, [target].concat(sources));
}

// Taken from https://www.npmjs.com/package/classnames
function classNames() {
  var _arguments = arguments;

  var classes = [];

  var _loop = function _loop(i) {
    var arg = _arguments.length <= i ? undefined : _arguments[i];

    if (arg) {
      var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

      if (argType === 'string' || argType === 'number') {
        classes.push(arg);
      } else if (Array.isArray(arg) && arg.length) {
        var inner = classNames.apply(undefined, _toConsumableArray(arg));
        if (inner) {
          classes.push(inner);
        }
      } else if (argType === 'object') {
        Object.keys(arg).forEach(function (key) {
          if ({}.hasOwnProperty.call(arg, key) && arg[key]) {
            classes.push(key);
          }
        });
      }
    }
  };

  for (var i = 0; i < arguments.length; i += 1) {
    _loop(i);
  }

  return classes.join(' ');
}

function handleKeyPress() {
  // console.log('handleKeyPress stub with action', action);
}


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/helpers/utils.js
// module id = 107
// module chunks = 0